import { render } from "./importcar.vue?vue&type=template&id=3dac7b02&ts=true"
import script from "./importcar.vue?vue&type=script&lang=ts"
export * from "./importcar.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__